module.exports = __webpack_public_path__ + "media/src/images/demoTop_number03-ad31d8badeb14e4bb000592117852ffc.png";